import axios from '@/lib/AxApi';

export default
{
    async selectRow(params)
    {
        const response = await axios.get('/ModuleCategories/selectRow', { params });

        return response.data;
    },
    async save(params)
    {
        const response = (params.id != null && params.id !== '')
            ? await axios.post('/ModuleCategories/updateRow', params)
            : await axios.post('/ModuleCategories/insertRow', params);

        return response.data;
    },
    async deleteRow(params)
    {
        const response = await axios.post('/ModuleCategories/deleteRow', params);

        return response.data;
    },
};
